import React from "react";
import "../../style/Footer/ButtonsLike.css";
import Button from "react-bootstrap/Button";
import {
  BsFillHandThumbsUpFill,
  BsFillHandThumbsDownFill,
} from "react-icons/bs";
import { useAppContext } from "../../AppContext";

export default function ButtonsLike() {
  const { globalState, setGlobalState } = useAppContext({});
  const handleSelect = (e) =>{
    const questionSeparator = globalState.questions.findIndex(question => question.type === 'image_choice_single')
    if(e===1){
      const newQuestions = globalState.questions.slice(0,questionSeparator)
      setGlobalState({
        ...globalState,
        questions: newQuestions,
        step: "2",
        aditionalNavbar: false,
        likeVideo: true
      });
    }else{
      const newQuestions = globalState.questions.slice(questionSeparator + 1)
      setGlobalState({
        ...globalState,
        questions: newQuestions,
        step: "2",
        aditionalNavbar: false,
        likeVideo: false
      });
    }
  }
  return (
    <>
        <div className="button-container">
          <Button
            variant="outline-danger"
            className="btn-icon dislike"
            onClick={() => handleSelect(2)}
          >
            <BsFillHandThumbsDownFill />
            <span className="button-text">No me gusta</span>
          </Button>
          <Button
            variant="outline-primary"
            className="btn-icon like"
            onClick={() => handleSelect(1)}
          >
            <BsFillHandThumbsUpFill />
            <span className="button-text">Me gusta</span>
          </Button>
        </div>
    </>
  );
}
